module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAkCAMAAABPJrEfAAAAAXNSR0IArs4c6QAAAGxQTFRFAAAAQEBAYGBgVVVVZWVlZGRkZWVlY2NjZmZmZWVlZGRkY2NjZWVlZmZmZWVlZmZmZGRkZmZmZmZmZWVlZWVlZmZmZWVlZWVlZmZmZmZmZWVlZmZmZmZmZmZmZWVlZmZmZWVlZmZmZmZmZmZmfilj4AAAACN0Uk5TAAQIDD9AREhLTE9QWGdvc3+Hj5OXm5+rr7fDw8vT29/v8/uzR/jhAAAAjElEQVQoz+3TSxKCMBBF0RcQFT8xoKgooOTuf4/OKIGkdK53egbprupIiWs903xrjZTeCFcbOXy5yqblJ7DqKBSqohEsg7blKciClsHfftbsIpQFEe+DfTVLen5UacRKwEWsBi5jG25+D+zeb76jHN7Pi3z0Vxz+uJ5tvqnAKrlHtrsayRzafgZ9Y41eGAcpZCZGKJUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/phone.png
// module id = piLn
// module chunks = 1